export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_CUSTOMER(state, customer) {
    state.customer = customer;
  },
  SET_CUSTOMERS(state, customers) {
    state.customers = customers;
  },
  ADD_CUSTOMER(state, customer) {
    state.customers.push(customer);
  },
  UPDATE_CUSTOMER(state, customer) {
    const certIndex = state.customers.findIndex(
      e => e.customerId === customer.customerId
    );
    Object.assign(state.customers[certIndex], customer);
  },
  DELETE_CUSTOMER(state, itemId) {
    const certIndex = state.customers.findIndex(u => u.customerId === itemId);
    state.customers.splice(certIndex, 1);
  }
};
